import { Component, Input, OnChanges, OnInit, SimpleChanges, ChangeDetectorRef, inject, DestroyRef, effect } from '@angular/core';
import { EngagementService } from 'src/app/shared/services/engagement/engagement.service';
import { HelpersService } from 'src/app/shared/services/helpers/helpers.service';
import * as moment from 'moment';
import * as _ from 'lodash';
import { Subscription } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { debounceTime, Subject } from 'rxjs';
import { NgIf } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { LtmsWidgetToolsComponent } from '../../ltms-widget-tools/ltms-widget-tools.component';
import { LtmsErrorComponent } from '../../ltms-error/ltms-error.component';
import { LtmsDataTableV2Component } from '../../ltms-data-table-v2/ltms-data-table-v2.component';
import { LtmsLoaderComponent } from '../../ltms-loader/ltms-loader.component';
import { AppStateService } from 'src/app/shared/services/helpers/app-state.service';
import { ScoreDropdownMenuComponent } from '../../score/score-dropdown-menu/score-dropdown-menu.component';
import { applyComparisonApiDateRange } from 'src/app/shared/utils/comparison-api-date-range.util';

@Component({
    selector: 'app-engagement-details',
    templateUrl: './engagement-details.component.html',
    styleUrls: ['./engagement-details.component.scss'],
    imports: [NgIf, FormsModule, LtmsWidgetToolsComponent, LtmsErrorComponent, LtmsDataTableV2Component, LtmsLoaderComponent, ScoreDropdownMenuComponent]
})
export class EngagementDetailsComponent implements OnInit, OnChanges {
  @Input() isDeviationEnabled = false;
  deviationComparisonLabel = '';
  // restrictToday: boolean = localStorage.getItem('restrictToday') !== null
  //   ? JSON.parse(localStorage.getItem('restrictToday')!)
  //   : false;
  restrictToday: boolean = false;
  isDataAvailable: boolean = false;
  footerData: any = {};
  selectedOption: any = {}; // Model bound to the select element
  dates = {
    startDate: '',
    endDate: ''
  };
  mainDiscription: string = 'Explore granular conversation request metrics broken down by various dimensions like Hierarchy and Time-trends. Analyze Records Journey for in-depth insights.';
  isAccount: boolean = true;
  totalSummary = {
    "current": {},
    "previous": {}
  }
  dataClone: any[] = [];
  tableData: any[] = [];
  raterTypeOb = { value: -1 }; // should be dynamically updated
  overall_summary_details: any;
  sortedData: any[] = [];
  tableHeader: any;
  selectedRowFilter: any = {};
  field_id: any;
  project_type: number = 0;
  customFilterOptions: any;
  exportData: any;
  isDataProcessed: boolean = false;
  hierarchyLabelMapping: any[] = [];
  selectedLevel: any;
  errorCode: string = '404';
  private Subscription?: Subscription;
  destroyRef = inject(DestroyRef);
  isDataLoaded: boolean = false
  feedSearch: any = {
    selectedOption: {},
    selectedFilter: {},
    // placeholder: "Please search",
    options: [],
    filteredOptions: []
  };
  datefiltercache: any = {};
  trenddatacache: any = {};
  searchTerm: string = '';
  private searchSubject = new Subject<Event>();
  pagingDetails: any = {
    start: 0,
    end: 0,
    pageSize: 10,
    pageNumber: 1,
    total: 0,
    totalpages: 0
  }
  pagingButtons: any = {
    isNext: false,
    isPrevious: false,
    isLast: false,
    isFirst: false
  }

  widgetConfig: any = {
    "elementId": "ltms-widget-" + new Date().getMilliseconds(),
    //TODO
    "download": {
      enable: true,
      disabled: true, // disable button and click
      componentId: '',
      data: {
        "accountOrProjectName": '',
        "headers": [],
        "body": [],
        rows: [],
        columns: [],
        title: "Engagement Detils",
        fileName: "Engagement Details"
      },
      query: {}
    },
    "fullscreen": {
      enable: false,
      componentId: 'tableId'
    }
  }

  requestsJourneyHeader: any[] = [{
    header: "ID",
    dataKey: "name",
    enabled: true,
    dataType: "string",
    clickable: true,
    headerType: 'dropdown',
    order: 1,
    selectedValue: {},
    options: [],
    style: {
      headerTextAlign: 'left',
      cellTextAlign: 'left'
    }
  },
  {
    "header": "Records Received",
    "dataKey": "formated_number_of_requests_received",
    "sortBy": "number_of_requests_received",
    "dataType": 'string',
    "order": 2,
    "width": "20%",
    "is_deviation_enabled": false,
    "enabled": true,
    "style": {
      "headerTextAlign": 'left',
      "cellTextAlign": 'right'
    }

  },
  {
    "header": "Records Filtered Out",
    "dataKey": "formated_number_of_requests_filtered",
    "sortBy": "number_of_requests_filtered",
    "dataType": 'string',
    "order": 2,
    "width": "50%",
    "is_deviation_enabled": false,
    "enabled": true,
    "style": {
      "headerTextAlign": 'left',
      "cellTextAlign": 'right'
    }
  }, {
    "header": "Eligible Records",
    "dataKey": "formated_number_of_requests_eligible",
    "sortBy": "number_of_requests_eligible",
    "dataType": 'string',
    "order": 2,
    "width": "50%",
    "is_deviation_enabled": false,
    "enabled": true,
    "style": {
      "headerTextAlign": 'left',
      "cellTextAlign": 'right'
    }
  }, {
    "header": "Records Failed",
    "dataKey": "formated_number_of_requests_all_attempts_failed",
    "sortBy": "number_of_requests_all_attempts_failed",
    "dataType": 'string',
    "order": 2,
    "width": "20%",
    "is_deviation_enabled": false,
    "enabled": true,
    "style": {
      "headerTextAlign": 'left',
      "cellTextAlign": 'right'
    }
  }, {
    "header": "Records Sent",
    "dataKey": "formated_number_of_unique_requests_sent",
    "sortBy": "number_of_unique_requests_sent",
    "dataType": 'string',
    "order": 2,
    "width": "20%",
    "is_deviation_enabled": false,
    "enabled": true,
    "style": {
      "headerTextAlign": 'left',
      "cellTextAlign": 'right'
    }
  }, {
    "header": "Records Undelivered",
    "dataKey": "formated_number_of_requests_undelivered",
    "sortBy": "number_of_requests_undelivered",
    "dataType": 'string',
    "order": 2,
    "width": "20%",
    "is_deviation_enabled": false,
    "enabled": true,
    "style": {
      "headerTextAlign": 'left',
      "cellTextAlign": 'right'
    }
  }, {
    "header": "Records Delivered",
    "dataKey": "formated_number_of_unique_requests_delivered",
    "sortBy": "number_of_unique_requests_delivered",
    "dataType": 'string',
    "order": 2,
    "width": "20%",
    "is_deviation_enabled": false,
    "enabled": true,
    "style": {
      "headerTextAlign": 'left',
      "cellTextAlign": 'right'
    }
  },
  {
    "header": "Links Opened",
    "dataKey": "formated_feedback_link_open_count",
    "sortBy": "feedback_link_open_count",
    "dataType": 'string',
    "order": 2,
    "width": "20%",
    "is_deviation_enabled": false,
    "enabled": true,
    "style": {
      "headerTextAlign": 'left',
      "cellTextAlign": 'right'
    }
  },
  {
    "header": "Responses Received",
    "dataKey": "formated_number_of_request_generated_rated",
    "sortBy": "number_of_request_generated_rated",
    "dataType": 'string',
    "order": 2,
    "width": "20%",
    "is_deviation_enabled": false,
    "enabled": true,
    "style": {
      "headerTextAlign": 'left',
      "cellTextAlign": 'right'
    }
  }, {
    "header": "Response Rate (%)",
    "dataKey": "formated_response_rate",
    "sortBy": "response_rate",
    "dataType": 'string',
    "order": 2,
    "width": "20%",
    "is_deviation_enabled": false,
    "enabled": true,
    "style": {
      "headerTextAlign": 'left',
      "cellTextAlign": 'right'
    }
  }];
  hierarchyStack: any;
  selectedTrend: any;

  brandId: any = null;
  accountId: any = null
  accessLevelandValue: any = null
  tableConfig: any = {
    addEmptyRows: true,
    minEmptyRows: 7,
    isExternalSort: true
  }
  constructor(
    private helpersService: HelpersService,
    public engagementService: EngagementService,
    private cdr: ChangeDetectorRef, // Inject ChangeDetectorRef
    private appStateService: AppStateService
  ) {
    effect(() => {
      if (this.appStateService.initialized()) {
        let datePickerObj: any = this.appStateService.datePicker();
        this.dates.startDate = datePickerObj.startDate;
        this.dates.endDate = datePickerObj.endDate;
        this.deviationComparisonLabel = this.helpersService.getDeviationComparisonLabel(datePickerObj);
        this.restrictToday = !this.engagementService.is_valid_date_range(this.dates.endDate, this.dates.startDate)
        if (Helpers && Helpers["isAccount"] && Helpers["isAccount"] == true) { this.isAccount = true } else { this.isAccount = false }
        // this.field_id = response.hierarchyStack ? Helpers.hierarchyStack : [];
        if (!Helpers.isAccount) {
          let hierarchyStack: any = this.appStateService.hierarchyStack() ? this.appStateService.hierarchyStack() : [];
          this.customFilterOptions = []; // Clear existing filters
          if (hierarchyStack.length) {
            this.field_id = hierarchyStack[hierarchyStack.length - 1]?.field_id
          } else {
            //todo [branddetails hierarchy level ,take 1st level, if there is no ]
            this.field_id = "h_0_0"
          }
          let accessString: any = null;
          if (hierarchyStack && hierarchyStack.length) {
            accessString = hierarchyStack[0].field_id + ":" + hierarchyStack[0].group_key[0]
          }
          let brandDetails: any = this.appStateService.brandDetails()
          if (_.hasIn(brandDetails, '_id')) {
            this.getDropDownOption();
            if ((this.brandId != brandDetails._id) || this.accessLevelandValue != accessString) {
              this.brandId = brandDetails._id
              this.accessLevelandValue = accessString;
              const datePicker: any = _.cloneDeep(_.get(Helpers, 'datePicker', null));
              if (!_.isEqual(_.cloneDeep(datePicker), _.cloneDeep(this.datefiltercache))) {
                this.datefiltercache = _.cloneDeep(datePicker);
                // this.getDropDownOption();
              }

            } else {
              this.getOverallSummary();
            }
          } else {
            // console.log("Brand Details not loaded...")
          }
        } else {
          this.brandId = null;
          this.accessLevelandValue = null;
          this.field_id = "project"
          let project_type_obj: any = this.appStateService.projectType()
          this.project_type = project_type_obj?.project_type;
          this.customFilterOptions = []; // Clear existing filters
          this.engagementService.prepareScalerRaterType()
          let accountDetails: any = this.appStateService.accountDetails()
          if (_.hasIn(accountDetails, '_id')) {
            this.getDropDownOption();
            if (this.accountId != accountDetails._id) {
              this.accountId = accountDetails._id
              // this.getDropDownOption();
            } else {
              this.getOverallSummary();
            }
          } else {
            // console.log("Account Details not loaded...")
          }
        }
      }
    })
    this.helpersService.datePicker.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((datePicker: any) => {
      if (datePicker) {
        this.deviationComparisonLabel = this.helpersService.getDeviationComparisonLabel(datePicker);
      }
    });
  }

  ngOnInit() {
    // const storedValue = localStorage.getItem('restrictToday');
    // if (storedValue !== null) {
    //   // Parse and set `restrictToday` if the value exists
    //   this.restrictToday = JSON.parse(storedValue);
    // } else {
    //   // Initialize with default value and store it in localStorage
    //   this.restrictToday = false;
    //   localStorage.setItem('restrictToday', JSON.stringify(this.restrictToday));
    // }
    // this.initialize();
    this.feedSearch.filteredOptions = [...this.feedSearch.options];
    this.getTableHeader(this.isDeviationEnabled);
    // Handle search with debounce
    this.searchSubject.pipe(debounceTime(300)).subscribe((event: Event) => {
      this.handleSearch(event);
    });
  }

  onSearchInput(event: Event) {
    const input = (event.target as HTMLInputElement).value;
    this.searchTerm = input;
    const trimmedInput = input.trim();
    if (trimmedInput === '') {
      this.clearSearch(); //  Call clearSearch when input is empty
      return;
    }
    //  Ensure immediate search execution and debounce for efficiency
    this.handleSearch(event);
    this.searchSubject.next(event);
  }
  private handleSearch(event: Event) {
    this.feedSearch.options = this.dataClone;
    const searchTerm = (event.target as HTMLInputElement).value.trim();
    if (!this.feedSearch.options || !Array.isArray(this.feedSearch.options)) {
      return;
    }
    this.feedSearch.filteredOptions = this.feedSearch.options.filter(option => {
      if (typeof option === 'string') {
        return option.toLowerCase().includes(searchTerm.toLowerCase());
      } else if (typeof option === 'object' && option.name) {
        return option.name.toLowerCase().includes(searchTerm.toLowerCase());
      }
      return false;
    });

    this.pagingDetails.pageNumber = 1;
    this.updatePagingDetails(
      this.feedSearch.filteredOptions.length,
      this.pagingDetails.pageNumber,
      this.feedSearch.filteredOptions
    );
    this.tableData = this.feedSearch.filteredOptions.slice(
      this.pagingDetails.start - 1,
      this.pagingDetails.end
    );

    this.cdr.detectChanges(); // Force Angular to update the UI
  }
  clearSearch(): void {
    this.searchTerm = '';
    this.feedSearch.filteredOptions = [...this.dataClone];
    this.pagingDetails.pageNumber = 1;
    this.updatePagingDetails(
      this.feedSearch.filteredOptions.length,
      this.pagingDetails.pageNumber,
      this.feedSearch.filteredOptions
    );
    this.tableData = this.feedSearch.filteredOptions.slice(
      this.pagingDetails.start - 1,
      this.pagingDetails.end
    );
    this.cdr.detectChanges(); //  Force UI update immediately
  }
  onOptionChange($event){
    if($event?.field_id){
      this.engagementService.setSelectedRaterType($event);
      this.getOverallSummary();
    }
  }
  // not is use, added to the effect in constructor 
  initialize() {
    if (Helpers && Helpers["isAccount"] && Helpers["isAccount"] == true) { this.isAccount = true } else { this.isAccount = false }

    this.helpersService.appState.subscribe((response: any) => {
      // this.field_id = response.hierarchyStack ? Helpers.hierarchyStack : [];
      if (response && !response.pending) {
        if (!Helpers.isAccount) {
          let hierarchyStack = response.hierarchyStack ? Helpers.hierarchyStack : []
          this.customFilterOptions = []; // Clear existing filters
          if (hierarchyStack.length) {
            this.field_id = hierarchyStack[hierarchyStack.length - 1].field_id
          } else {
            //todo [branddetails hierarchy level ,take 1st level, if there is no ]
            this.field_id = "h_0_0"
          }
          let accessString: any = null;
          if (hierarchyStack && hierarchyStack.length) {
            accessString = hierarchyStack[0].field_id + ":" + hierarchyStack[0].group_key[0]
          }
          if (_.hasIn(response, 'brandDetails._id')) {
            this.getDropDownOption();
            if ((this.brandId != response.brandDetails._id) || this.accessLevelandValue != accessString) {
              this.brandId = response.brandDetails._id
              this.accessLevelandValue = accessString;
              const datePicker: any = _.cloneDeep(_.get(Helpers, 'datePicker', null));
              if (!_.isEqual(_.cloneDeep(datePicker), _.cloneDeep(this.datefiltercache))) {
                this.datefiltercache = _.cloneDeep(datePicker);
                // this.getDropDownOption();
              }

            } else {
              this.getOverallSummary();
            }
          } else {
            // console.log("Brand Details not loaded...")
          }


        } else {
          this.brandId = null;
          this.accessLevelandValue = null;
          this.field_id = "project"
          this.project_type = response?.projectType?.project_type;
          this.customFilterOptions = []; // Clear existing filters
          if (_.hasIn(response, 'accountDetails._id')) {
            this.getDropDownOption();
            if (this.accountId != response.accountDetails._id) {
              this.accountId = response.accountDetails._id
              // this.getDropDownOption();
            } else {
              this.getOverallSummary();
            }
          } else {
            // console.log("Account Details not loaded...")
          }
        }
      }
    });


  }
  formatNumber(value: number | string): string {
    if (typeof value === 'string' && value.endsWith('%')) {
      return value; // Return the percentage string as is
    }
    if (isNaN(Number(value))) return '0';
    const number = typeof value === 'string' ? Number(value) : value;

    const numberString = number.toString();
    const [integerPart, decimalPart] = numberString.split('.');
    let lastThreeDigits = integerPart.slice(-3);
    let otherDigits = integerPart.slice(0, -3);
    if (otherDigits) {
      lastThreeDigits = ',' + lastThreeDigits;
    }
    const formattedIntegerPart = otherDigits.replace(/\B(?=(\d{2})+(?!\d))/g, ',') + lastThreeDigits;
    return decimalPart ? formattedIntegerPart + '.' + decimalPart : formattedIntegerPart;
  }
  /**
  * this function is to get overall summary based on view type trends or hierarchy
  */

  getOverallSummary(trend_data?: any) {
    var field_id = ''
    if (trend_data) {
      this.trenddatacache = _.cloneDeep(trend_data)
      field_id = trend_data.field_id
      this.selectedOption = trend_data;
    } else {
      field_id = this.selectedOption?.field_id
    }
    this.clearSearch();
    this.tableData = [];
    this.dataClone = [];
    this.sortedData = [];  // Initialize as empty array instead of null
    this.isDataAvailable = false;

    const formatDate = (date: Date): string => {
      const year = date.getFullYear();
      const month = (date.getMonth() + 1).toString().padStart(2, "0");
      const day = date.getDate().toString().padStart(2, "0");
      return `${year}${month}${day}`;
    };

    const startDate = (this.dates.startDate);
    const endDate = (this.dates.endDate);
    // const today = new Date();
    // const yesterday = new Date();
    // yesterday.setDate(today.getDate() - 1);
    // if (startDate === formatDate(today) || startDate === formatDate(yesterday)) {
    //   this.restrictToday = true;
    //   this.isDataLoaded = true;

    //   localStorage.setItem('restrictToday', JSON.stringify(this.restrictToday));
    //   return;
    // }
    // this.restrictToday = false;

    var params = this.engagementService.getDetailsParams({
      "query_type": 4,
      "is_trend_data": false,
      "field_id": field_id,
      "view_type": trend_data ? trend_data.view_type : this.trenddatacache?.view_type,
      "trend_type": trend_data ? trend_data.value : this.trenddatacache?.value,
      from: startDate,
      to: endDate,
      "is_deviation_enabled": this.isDeviationEnabled,
    })
    applyComparisonApiDateRange(params, Helpers?.datePicker);
    this.isDataLoaded = this.restrictToday ? true : false;
    // this.restrictToday = false;
    if (this.project_type) {
      params.project_type = this.project_type;
    }
    this.Subscription = this.engagementService.getEngagementSummary(params)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: (response) => {
          this.dataClone = []; // Reset array
          this.tableData = []; // Reset array
          this.sortedData = []; // Initialize as empty array instead of null

          if (
            response &&
            response.code === 0 &&
            response.data.overall_summary_details &&
            (
              (response.data.overall_summary_details.overall_summary &&
                Object.keys(response.data.overall_summary_details.overall_summary).length > 0) ||
              (response.data.overall_summary_details.trends &&
                Object.keys(response.data.overall_summary_details.trends).length > 0)
            )
          ) {
            this.overall_summary_details = response.data.overall_summary_details;
            this.filterDataBasedOnRaterType(this.raterTypeOb);

            if (params.view_type === 'hierarchy') {
              this.processHierarchyData(response.data.overall_summary_details);
              this.isDataLoaded = true;
            }

            if (params.view_type === "trend") {
              this.processTrendsdata(response.data.overall_summary_details);
              this.isDataLoaded = true;
            }

            // Format the data after processing
            this.dataClone = this.dataClone.map(item => {
              return {
                ...item,
                formated_number_of_requests_received: this.formatNumber(item.number_of_requests_received),
                formated_number_of_requests_filtered: this.formatNumber(item.number_of_requests_filtered),
                formated_number_of_requests_eligible: this.formatNumber(item.number_of_requests_eligible),
                formated_number_of_requests_all_attempts_failed: this.formatNumber(item.number_of_requests_all_attempts_failed),
                formated_number_of_unique_requests_sent: this.formatNumber(item.number_of_unique_requests_sent),
                formated_number_of_requests_undelivered: this.formatNumber(item.number_of_requests_undelivered),
                formated_number_of_unique_requests_delivered: this.formatNumber(item.number_of_unique_requests_delivered),
                formated_feedback_link_open_count: this.formatNumber(item.feedback_link_open_count),
                formated_number_of_request_generated_rated: this.formatNumber(item.number_of_request_generated_rated),
                formated_response_rate: this.formatNumber(item.response_rate) + "%",
              };
            });

            // Initialize pagination with the formatted data
            this.feedSearch.filteredOptions = [...this.dataClone];
            this.updatePagingDetails(this.dataClone.length, 1, this.dataClone);

            this.applyFormattedValuesToDataClone();
            this.feedSearch.filteredOptions = [...this.dataClone];
            this.updatePagingDetails(this.dataClone.length, 1, this.dataClone);
            this.footerData = this.buildFooterData();

            this.widgetConfig['download']['data']['columns'] = this.requestsJourneyHeader.map((item, index) => {
              if (index === 0) {
                return {
                  order: index + 1,
                  header: this.selectedOption?.name ? this.selectedOption.name : "ID",
                  dataKey: item.dataKey,
                };
              }
              return {
                order: index + 1,
                header: item.header,
                dataKey: item.dataKey,
              };
            });
            this.widgetConfig['download']['data']['rows'] = [...this.dataClone]; // Include the dataClone rows
              if (this.footerData) {
                this.widgetConfig['download']['data']['rows'].push(this.footerData); // Append the total row to the rows if available
              }

            if (this.dataClone.length > 100 && !this.isAccount) {
              this.widgetConfig["dashboardReportingJob"] = true;
              this.widgetConfig['download']['data']['fileName'] = "Engagement Details " + this.selectedOption?.name;
              this.widgetConfig['download']['query'] = {
                account_id: params['account_id'] ? params['account_id'] : "",
                brand_id: params['brand_id'] ? params['brand_id'] : "",
                field_id: null,
                field_type: null,
                column_type: "Records Journey",
                search_possible_values: false,
                report_name: "Engagement Details " + this.selectedOption?.name,
                report_type: "statistics_advanced_download",
                api_url: 'v1/litmus_analytics/engagement/summary_by_account',
                parameters: [params]
              };
            } else {
              delete this.widgetConfig["dashboardReportingJob"];
              // this.widgetConfig['download']['data']['rows'] = [...this.dataClone]; // Include the dataClone rows
              // if (this.footerData) {
              //   this.widgetConfig['download']['data']['rows'].push(this.footerData); // Append the total row to the rows if available
              // }
              if (this.selectedOption?.name && this.selectedOption.name !== "") {
                this.widgetConfig['download']['data']['fileName'] = "Engagement Details " + this.selectedOption.name;
                this.widgetConfig['download']['data']['title'] = "Engagement Details - " + this.selectedOption.name;
              }
            }

          } else {
            this.isDataAvailable = false;
            this.tableData = [];
            this.isDataLoaded = true;
            this.footerData = null;
            this.updatePagingDetails(0, 1, []);
          }
        },
        error: (err) => {
          this.isDataLoaded = true;
          this.tableData = []; // Clear tableData on error
          this.dataClone = []; // Clear dataClone on error
          this.isDataAvailable = false;
          this.footerData = null; // Ensure footerData is cleared on error
          if (err.status === '500') {
            this.errorCode = '500';
          } else if (err.status === "404") {
            this.errorCode = '404';
          } else if (err.status === "408") {
            this.errorCode = '408';
          }
        }
      });

  }
  truncateString(value: string, limit: number = 11, ellipsis: string = '...'): string {
   return value;
  }

  /**
  * processing hierarchy data for brands present in response
  * @param response used to process data with the overall summary and brands present in response
  */
  processHierarchyData(response) {
    this.tableData = [];  // Clear old data
    this.dataClone = [];  // Clear old clone
    this.isDataAvailable = false; // Reset availability status
    this.totalSummary = { current: {}, previous: {} };
    if (response && response.overall_summary) {
      let overall_summary = response.overall_summary;
      let hierarchy_data = {};
      let summaryType = "";
      let tableData: any[] = [];
      if (response.brands && !_.isEmpty(response.brands)) {
        hierarchy_data = response.brands;
        summaryType = "brand";
      } else if (response.groups && !_.isEmpty(response.groups)) {
        hierarchy_data = response.groups;
        summaryType = "group";
      } else if (response.shops && !_.isEmpty(response.shops)) {
        hierarchy_data = response.shops;
        summaryType = "shop";
      }
      // if (!_.isEmpty(response.overall_summary)) {
      //   _.each(response.overall_summary, (details, key) => {
      //     if ((overall_summary && overall_summary[key] && !this.isAccount) || (this.isAccount)) {
      //       let data = this.prepareSummaryData(overall_summary[key], false);
      //       const fullName = (hierarchy_data[key]) ? hierarchy_data[key].name : key;
      //       data.name = this.truncateString(fullName, 10); // Truncated name for table display
      //       data.tooltip_text = { name: fullName }; // Full name for tooltip
      //       data.id = key;
      //       data.main_rater_type = response.brands ? response.brands[key].main_rater_type : null;
      //       data.summary_type = summaryType;
      //       tableData.push(data);
      //     }
      //   });
      // }
      _.each(hierarchy_data, (details, key) => {
        if ((overall_summary && overall_summary[key] && !this.isAccount) || (this.isAccount)) {
          let data = this.prepareSummaryData(overall_summary[key], false);
          const fullName = details.name || key;
          data.name = this.truncateString(fullName, 11);
          data.tooltip_text = { name: fullName };
          data.id = key;
          data.main_rater_type = response.brands ? response.brands[key].main_rater_type : null;
          data.summary_type = summaryType;
          tableData.push(data);
        }
      });

      this.dataClone = JSON.parse(JSON.stringify(tableData));
      if (tableData && tableData.length) {
        // Initialize pagination with the full dataset
        this.updatePagingDetails(this.dataClone.length, 1, this.dataClone);
        this.isDataAvailable = true;
      }

    } else {
      this.isDataAvailable = true;
      this.tableData = [];
      this.dataClone = [];
      this.updatePagingDetails(0, 1, []); // Initialize empty pagination
    }
  }

  /**
  * this funtion is used to prepare date for each hierarchy and date data.
  * @param summary_data 
  * @param is_total_summary 
  * @returns it returns current summary
  */
  prepareSummaryData(summary_data, is_total_summary) {
    let current_summary = this.getSummary({});
    let current = (summary_data && summary_data.summary && summary_data.summary.current && !_.isEmpty(summary_data.summary.current)) ? summary_data.summary.current : {};
    let previous = (summary_data && summary_data.summary && summary_data.summary.previous && !_.isEmpty(summary_data.summary.previous)) ? summary_data.summary.previous : {};
    let rater_type = -1; // null : todo :- below commented because main rater type is not present

    if (!_.isEmpty(current)) {
      let response_rate = this.engagementService.getResponeRate(current);
      current.response_rate = response_rate;
      if (is_total_summary) {
        if ((rater_type == 3 || rater_type == 10)) {
          let sum = (current.promoters || 0) + (current.passives || 0) + (current.detractors || 0);
          current.response_score = (sum > 0) ? ((((current.promoters || 0) / sum) * 100) - (((current.detractors || 0) / sum) * 100)).toFixed() : 0;
        } else {
          current.response_score = (current.sum_primary_rating / current.number_of_users_rated_primary_rating) ? (current.sum_primary_rating / current.number_of_users_rated_primary_rating).toFixed() : 0;
        }
      } else {
        current.response_score = this.engagementService.getResponseScore(current, rater_type).toFixed();
      }
      current_summary = this.getSummary(current);
      if (!is_total_summary) {
        this.totalSummary.current = this.addInTotalSummary(this.totalSummary.current, current_summary)
      }

      if (!_.isEmpty(previous)) {
        previous.response_rate = this.engagementService.getResponeRate(previous);
        previous.response_score = this.engagementService.getResponseScore(previous, rater_type);
        let previous_summary = this.getSummary(previous)
        if (!is_total_summary) {
          this.totalSummary.previous = this.addInTotalSummary(this.totalSummary.previous, previous_summary)
        }

        if (this.isDeviationEnabled) {
          current_summary.deviations = this.getDevationObject(current_summary, previous_summary);
        } else {
          current_summary.deviations = {};
        }
      } else {
        current_summary.deviations = {};
      }

    }
    return current_summary
  }

  /**
  * this function is used to prepare each detail in the data and assigning it to summary details
  * @param data 
  * @returns 
  */
  getSummary(data) {
    let summary: any = this.getDefaultSummary();
    // Reset arrays or objects if reused
    summary.failed_attempt_details = [];
    summary.channels = {};
    if (!_.isEmpty(data)) {
      // requests revieved
      summary.feedback_link_open_count = (data.feedback_link_open_count || 0);
      summary.number_of_requests_received = (this.engagementService.getRequestRecieved(data) || 0);
      summary.request_received_with_phone_number = (data.request_received_with_phone_number || 0);
      summary.request_received_with_email_address = (data.request_received_with_email_address || 0);
      summary.request_received_with_phone_number_and_email_address = (data.request_received_with_phone_number_and_email_address || 0);
      // incorrect requests
      summary.number_of_incorrect_requests_received = (data.number_of_incorrect_requests_received || 0);
      summary.incorrect_request_received_with_phone_number = (data.incorrect_request_received_with_phone_number || 0);
      summary.incorrect_request_received_with_email_address = (data.incorrect_request_received_with_email_address || 0);
      summary.incorrect_request_received_with_phone_number_and_email_address = (data.incorrect_request_received_with_phone_number_and_email_address || 0);

      // requests filtered
      summary.number_of_requests_filtered = (data.number_of_requests_filtered || 0) + (data.number_of_unprocessed_records || 0) + (data.number_of_records_without_phone_number_and_email_address || 0) - (data.number_of_records_without_phone_number_email_address_and_filtered_data || 0);
      summary.number_of_request_filtered_max_requests = (data.number_of_request_filtered_max_requests || 0);
      summary.number_of_request_filtered_already_responded = (data.number_of_request_filtered_already_responded || 0);
      summary.number_of_request_filtered_max_notification = (data.number_of_request_filtered_max_notification || 0);
      summary.number_of_request_filtered_single_notification = (data.number_of_request_filtered_single_notification || 0);
      summary.number_of_request_filtered_blacklisted = (data.number_of_request_filtered_blacklisted || 0);
      summary.number_of_request_filtered_deduplication = (data.number_of_request_filtered_deduplication || 0);
      // failed attemt
      summary.number_of_requests_all_attempts_failed = (data.number_of_requests_all_attempts_failed || 0);
      summary.requests_attempted_failed_invalid_by_sms = (data && this.hasProperty(data, 'requests_failed_attempted_details_by_overall.sms.invalid') && data.requests_failed_attempted_details_by_overall.sms.invalid) ? data.requests_failed_attempted_details_by_overall.sms.invalid : 0;
      summary.requests_attempted_failed_invalid_by_email = (data && this.hasProperty(data, 'requests_failed_attempted_details_by_overall.email.invalid') && data.requests_failed_attempted_details_by_overall.email.invalid) ? data.requests_failed_attempted_details_by_overall.email.invalid : 0;
      summary.requests_attempted_failed_by_provider_exception_sms = (data && this.hasProperty(data, 'requests_failed_attempted_details_by_overall.sms.provider_exception') && data.requests_failed_attempted_details_by_overall.sms.provider_exception) ? data.requests_failed_attempted_details_by_overall.sms.provider_exception : 0;
      summary.requests_attempted_failed_by_provider_exception_email = (data && this.hasProperty(data, 'requests_failed_attempted_details_by_overall.email.provider_exception') && data.requests_failed_attempted_details_by_overall.email.provider_exception) ? data.requests_failed_attempted_details_by_overall.email.provider_exception : 0;
      summary.number_of_miscellaneous = this.getTotalMiscellaneous(data);
      // request sent
      summary.number_of_unique_requests_sent = (data.number_of_unique_requests_sent || 0);

      summary.number_of_request_sent_by_sms = (data && this.hasProperty(data, 'requests_attempted_details_by_overall.sms.sent') && data.requests_attempted_details_by_overall.sms.sent) ? data.requests_attempted_details_by_overall.sms.sent : 0;
      summary.number_of_sms_part_sent = (data && this.hasProperty(data, 'requests_attempted_details_by_overall.sms.message_parts') && data.requests_attempted_details_by_overall.sms.message_parts) ? data.requests_attempted_details_by_overall.sms.message_parts : 0;
      summary.number_of_request_sent_by_email = (data && this.hasProperty(data, 'requests_attempted_details_by_overall.email.sent') && data.requests_attempted_details_by_overall.email.sent) ? data.requests_attempted_details_by_overall.email.sent : 0;
      // request undelivered
      summary.number_of_requests_undelivered = (data.number_of_requests_undelivered || 0);
      summary.dnd = (data && this.hasProperty(data, 'requests_attempted_details_by_channels.sms.dnd') && data.requests_attempted_details_by_channels.sms.dnd) ? data.requests_attempted_details_by_channels.sms.dnd : 0;
      summary.undelivered_sms = (data && this.hasProperty(data, 'requests_attempted_details_by_channels.sms.undelivered') && data.requests_attempted_details_by_channels.sms.undelivered) ? data.requests_attempted_details_by_channels.sms.undelivered : 0;
      summary.undelivered_email = (data && this.hasProperty(data, 'requests_attempted_details_by_channels.email.undelivered') && data.requests_attempted_details_by_channels.email.undelivered) ? data.requests_attempted_details_by_channels.email.undelivered : 0;
      // request delivered
      summary.number_of_unique_requests_delivered = (data.number_of_unique_requests_delivered || 0);
      summary.delivered_via_sms = (data && this.hasProperty(data, 'request_delivered_by_channels.sms.delivered') && data.request_delivered_by_channels.sms.delivered) ? data.request_delivered_by_channels.sms.delivered : 0;
      summary.delivered_via_email = (data && this.hasProperty(data, 'request_delivered_by_channels.email.delivered') && data.request_delivered_by_channels.email.delivered) ? data.request_delivered_by_channels.email.delivered : 0;

      summary.promoters = (data.promoters || 0);
      summary.detractors = (data.detractors || 0);
      summary.passives = (data.passives || 0);
      summary.sum_primary_rating = (data.sum_primary_rating || 0);
      summary.number_of_users_rated_primary_rating = (data.number_of_users_rated_primary_rating || 0);
      summary.response_rate = parseFloat(data.response_rate || 0);
      summary.response_score = (data.response_score || 0);
      summary.number_of_request_generated_rated = (data.number_of_request_generated_rated || 0);
      summary.number_of_request_generated = (data.number_of_request_generated || 0);

      // Records Eligible = Records Sent + Records Failed
      summary.number_of_requests_eligible = (summary.number_of_requests_all_attempts_failed || 0) + (data.number_of_unique_requests_sent || 0);
    }

    return summary
  }

  /**
  * this function merges data from data into container_obj 
  * @param container_obj 
  * @param data 
  * @returns 
  */
  addInTotalSummary(container_obj, data) {
    if (!_.isEmpty(data)) {
      // Reset container_obj if needed before aggregation
      container_obj = container_obj || {};
      _.each(data, function (value, key) {
        if (container_obj[key]) {
          if (typeof value == "number") {
            container_obj[key] = container_obj[key] + value
          } else {
            container_obj[key] = value
          }

        } else {
          container_obj[key] = value
        }
      })
    }

    return container_obj;

  }

  /**
  * this function iterates over the current object, calculate deviations from the previous object for each key,
  *  and store the results in the deviations object.
  * @param current 
  * @param previous 
  * @returns 
  */
  getDevationObject(current, previous) {
    let deviations = {}
    _.each(current, (value, key) => {
      deviations[key] = Helpers.getFieldDeviation(current[key], previous[key]);
    })
    return deviations;
  }

  /**
  * this function returns default summary values
  * @returns object containing default values
  */
  getDefaultSummary() {
    return {
      "number_of_requests_received": 0,
      "request_received_with_phone_number": 0,
      "request_received_with_email_address": 0,
      "request_received_with_phone_number_and_email_address": 0,
      "number_of_incorrect_requests_received": 0,
      "incorrect_request_received_with_phone_number": 0,
      "incorrect_request_received_with_email_address": 0,
      "incorrect_request_received_with_phone_number_and_email_address": 0,
      "number_of_requests_filtered": 0,
      "number_of_request_filtered_max_requests": 0,
      "number_of_request_filtered_already_responded": 0,
      "number_of_request_filtered_max_notification": 0,
      "number_of_request_filtered_single_notification": 0,
      "number_of_request_filtered_blacklisted": 0,
      "number_of_request_filtered_deduplication": 0,
      "number_of_requests_all_attempts_failed": 0,
      "number_of_requests_eligible": 0,
      "requests_attempted_failed_invalid_by_sms": 0,
      "requests_attempted_failed_invalid_by_email": 0,
      "requests_attempted_failed_by_provider_exception_sms": 0,
      "requests_attempted_failed_by_provider_exception_email": 0,
      "number_of_miscellaneous": 0,
      "number_of_unique_requests_sent": 0,
      "number_of_request_sent_by_sms": 0,
      "number_of_sms_part_sent": 0,
      "number_of_request_sent_by_email": 0,
      "number_of_requests_undelivered": 0,
      "dnd": 0,
      "undelivered_sms": 0,
      "undelivered_email": 0,
      "number_of_unique_requests_delivered": 0,
      "delivered_via_sms": 0,
      "delivered_via_email": 0,
      "response_rate": 0,
      "response_score": 0,
      "number_of_request_generated_rated": 0,
      "feedback_link_open_count": 0,
    }
  }

  /**
  * this functions adds up the sms and email
  * @param data 
  * @returns 
  */
  getTotalMiscellaneous(data) {
    let sms = (data && this.engagementService.getProp(data, 'requests_failed_attempted_details_by_overall.sms.miscellaneous')) ? this.engagementService.getProp(data, 'requests_failed_attempted_details_by_overall.sms.miscellaneous') : 0;
    let email = (data && this.engagementService.getProp(data, 'requests_failed_attempted_details_by_overall.email.miscellaneous')) ? this.engagementService.getProp(data, 'requests_failed_attempted_details_by_overall.email.miscellaneous') : 0;
    return (sms || 0) + (email || 0);
  }

  /**
  * This function checks whether all keys in the `keys` string (separated by ".")
  *  exist and are accessible in the `obj` object
  * @param obj 
  * @param keys 
  * @returns 
  */
  hasProperty(obj, keys) {
    return keys.split(".").every(function (key) {
      if (typeof obj != "object" || obj === null || !(key in obj)) {
        return false;
      }
      obj = obj[key];
      return true;
    });
  }

  /**
  * this function is used to get deviation for a single field
  * @param current 
  * @param previous 
  * @returns 
  * not needed as of now
  */
  // getFieldDeviation(current, previous) {
  //   current = (!isNaN(current)) ? parseFloat(current) : current;
  //   previous = (!isNaN(previous)) ? parseFloat(previous) : previous;
  //   if (!previous || isNaN(previous)) {
  //     previous = 0;
  //   }
  //   if (!current || isNaN(current)) {
  //     current = 0;
  //   }
  //   if (current == 0 && previous == 0) {
  //     return null;
  //   }
  //   if (!isNaN(current) && !isNaN(previous)) {
  //     let percentage = current - previous;
  //     if (percentage % 1) {
  //       percentage = parseFloat(percentage.toFixed(1));
  //     } else {
  //       percentage = parseInt(percentage.toFixed(0));
  //     }

  //     let deviation = {};
  //     if (percentage < 0) {
  //       deviation['arrowType'] = "down";
  //       percentage = -percentage;
  //     } else if (percentage > 0) {
  //       deviation['arrowType'] = "up";
  //     } else {
  //       deviation['arrowType'] = "no-change";
  //     }
  //     deviation['difference'] = percentage;
  //     return deviation;
  //   } else {
  //     return null;
  //   }
  // }

  /**
  * this function prepare option for drop down.
  */
  getDropDownOption() {
    this.customFilterOptions = [];
    const hierarchyOptions = this.getHierarchyOptions();
    const trendOptions = this.getTrendOptions();
    
    // Combine all options
    this.customFilterOptions = [...hierarchyOptions, ...trendOptions];
    // Handle empty hierarchy case. Defaulting to first trend option
    if (!hierarchyOptions.length && trendOptions.length) {
      this.selectedOption = trendOptions[0];
    } else {
      // Get default hierarchy option (h_0_0)
      const defaultHierarchyOption = hierarchyOptions.find(opt => opt.field_id === 'h_0_0') || hierarchyOptions[0];

      // Handle option selection
      if (this.selectedOption && Object.keys(this.selectedOption).length > 0) {
        if (this.selectedOption.view_type === 'hierarchy') {
          // For hierarchy, retain the selected option
          const matchingOption = this.customFilterOptions.find(opt =>
            opt.field_id === this.selectedOption.field_id && opt.view_type === 'hierarchy'
          );
          this.selectedOption = matchingOption || defaultHierarchyOption;
        } else {
          // For trends, reset to default hierarchy option (h_0_0)
          this.selectedOption = defaultHierarchyOption;
        }
      } else {
        this.selectedOption = defaultHierarchyOption;
      }
    }

    this.requestsJourneyHeader[0].dropdownConfig = {
      groupBy: "view_type",
      categorization: true,
      class: 'table-dropdown',
      options: JSON.parse(JSON.stringify(this.customFilterOptions))
    }
    
    this.getOverallSummary(this.selectedOption);
  }

  /**
 * this function is to get overall summary based on view type trends
 */


  // this function process and prepare trend data for datatable
  processTrendsdata(response: any): void {
    const tableData: any[] = [];
    this.isDataAvailable = false; // Reset flags
    this.totalSummary = { current: {}, previous: {} };
    if (response && response.trends && !_.isEmpty(response.trends)) {
      _.each(response.trends, (value, time) => {
        const nextDate = this.getNextDateString(time);
        value.time_in_millisecond = moment(time).valueOf();

        const previous = response.trends[nextDate] || {};
        previous.time_in_millisecond = moment(nextDate).valueOf();

        const overallSummary = {
          summary: {
            current: value,
            previous: previous
          }
        };

        const data = this.prepareSummaryData(overallSummary, false);
        const formattedDate = this.fromateDateString(time);
        data.name = this.truncateString(formattedDate, 11);
        data.tooltip_text = { name: formattedDate };
        data.time_in_millisecond = value.time_in_millisecond;
        tableData.push(data);
      });
    }

    this.dataClone = JSON.parse(JSON.stringify(tableData));
    if (this.exportData) {
      if (this.exportData?.data?.list_data) {
        this.exportData.data.list_data = []; // Clear previous data
      }
      this.exportData.size = tableData.length;
      this.exportData.data.list_data = JSON.parse(JSON.stringify(tableData));

      const totalSummaryData = this.prepareSummaryData({ summary: this.totalSummary }, true);
      totalSummaryData.name = "Total";
      totalSummaryData.id = "total_summary";

      this.exportData.data.list_data.push(totalSummaryData);
    }

    // Initialize pagination with the full dataset
    if (tableData.length) {
      this.updatePagingDetails(this.dataClone.length, 1, this.dataClone);
      this.isDataAvailable = true;
    } else {
      this.tableData = [];
      this.isDataAvailable = false;
      this.updatePagingDetails(0, 1, []); // Initialize empty pagination
    }

    this.isDataProcessed = true;
  }

  fromateDateString(dateString: string): string {
    if (this.selectedTrend?.trend_type === "hours") {
      return moment.utc(dateString).format("DD MMM YYYY, hh:mm A");
    }
    return moment.utc(dateString).format("DD MMM YYYY");
  }

  getNextDateString(time: any): string {
    const date = moment(time).add(1, this.selectedOption?.trend_type);
    return date.toISOString();
  }


  /**
  * This function add hierarchy option in row dropdown
  */
  getHierarchyOptions() {
    let hierarchyOptions: any[] = [];
    if (this.isAccount) {
      //   hierarchyOptions = [{
      //     "label": "Projects",
      //     "view_type": "hr"
      // }];
      hierarchyOptions.push({
        "name": "Projects",
        "view_type": "hierarchy",
        "field_id": "project"
      })
    } else {
      var hierarchyStack;
      this.helpersService.appState.subscribe((response: any) => {
        if (response && !response.pending) {
          hierarchyStack = response.hierarchyStack ? Helpers.hierarchyStack : [];
        }
      });
      var hierarchyList = _.cloneDeep(Helpers.brandDetails.hierarchy_list);
      var hierarchyAlias = _.cloneDeep(Helpers.brandDetails.hierarchy_list_alias);
      var key = _.find(Object.keys(hierarchyAlias), function (data) {
        return (data != 'default')
      });

      if (hierarchyList && hierarchyList[key] && hierarchyList[key].length > 1) {
        if (hierarchyStack && hierarchyStack.length) {
          var alias = _.sortBy(hierarchyStack, ["field_id"])
          var alias_name = alias[alias.length - 1].field_id
          this.field_id = alias_name
          var hierarchy_name;
          for (var key in hierarchyAlias) {
            if (alias_name.indexOf(hierarchyAlias[key].name) >= 0) {
              hierarchy_name = key;
              break;
            }
          }
          if (hierarchy_name) {
            var levelIndex = hierarchyAlias[hierarchy_name].values.indexOf(alias_name)
            // for (var idx in hierarchyAlias[hierarchy_name].values) {
            for (var idx = levelIndex; idx < hierarchyAlias[hierarchy_name].values.length; idx++) {

              if (hierarchyList[hierarchy_name][idx]) {
                var field_id = hierarchyAlias[hierarchy_name].values[idx]
                this.hierarchyLabelMapping[field_id] = hierarchyList[hierarchy_name][idx]
                if (parseInt(idx) >= levelIndex) {
                  hierarchyOptions.push({
                    "name": hierarchyList[hierarchy_name][idx],
                    "field_id": field_id,
                    "view_type": "hierarchy",
                  })
                }

              }
            }
          }

        } else {
          hierarchyAlias[key].values.splice(0, 1);
          hierarchyList[key].splice(0, 1);
          this.selectedLevel = hierarchyAlias[key].values[0]
          for (var idx in hierarchyAlias[key].values) {
            if (hierarchyList[key][idx]) {
              var field_id = hierarchyAlias[key].values[idx]
              this.hierarchyLabelMapping[field_id] = hierarchyList[key][idx]
              hierarchyOptions.push({
                "name": hierarchyList[key][idx],
                "field_id": field_id,
                "view_type": "hierarchy"
              })
            }
          }

        }
        // if (Helpers.brandDetail.is_single_touchpoint_setup == true) {
        //     this.hierarchyLabelMapping["shop_id"] = "Touchpoints"
        //     hierarchyOptions.push({
        //         "label": "Touchpoints",
        //         "field_id": "shop_id",
        //         "view_type": "hierarchy"
        //     });
        // }
      }
    }

    return hierarchyOptions;
  }

  /**
  * this function add trend option depending on date range.
  * @returns 
  */
  getTrendOptions(): any[] {
    let trendOptions: any[] = [];
    let hourly = { name: "Hourly", "view_type": "trend", "field_id": "hours", "trend_type": "hours", value: 0 };
    let daily = { name: "Daily", "view_type": "trend", "field_id": "day", "trend_type": "day", value: 1 };
    let weekly = { name: "Weekly", "view_type": "trend", "field_id": "weeks", "trend_type": "weeks", value: 2 };
    let monthly = { name: "Monthly", "view_type": "trend", "field_id": "months", "trend_type": "months", value: 3 };
    let quarterly = { name: "Quarterly", "view_type": "trend", "field_id": "quarters", "trend_type": "quarters", value: 4 };
    let yearly = { name: "Yearly", "view_type": "trend", "field_id": "years", "trend_type": "years", value: 5 };

    let fromDate = this.dates.startDate || this.helpersService.helpers['datePicker'].startDate;
    let toDate = this.dates.endDate || this.helpersService.helpers['datePicker'].endDate;
    let from = moment(fromDate, "YYYYMMDD").startOf('date');
    let to = moment(toDate, "YYYYMMDD").endOf('date');

    let dtDiff = to.diff(from, 'days');

    // Reset selectedTrend
    this.selectedTrend = null;

    if (dtDiff === 0) {
      trendOptions.push(hourly);
      this.selectedTrend = hourly;
    } else if (dtDiff <= 31) { // Changed from 6 to 31 for monthly view
      trendOptions.push(daily);
      if (dtDiff >= 7) { // If range is 7 days or more, add weekly option
        trendOptions.push(weekly);
      }
      this.selectedTrend = daily; // Default to daily for monthly view
    } else if (dtDiff < 90) { // 3 months
      trendOptions.push(daily);
      trendOptions.push(weekly);
      trendOptions.push(monthly);
      this.selectedTrend = weekly;
    } else if (dtDiff < 365) { // 1 year
      trendOptions.push(weekly);
      trendOptions.push(monthly);
      trendOptions.push(quarterly);
      this.selectedTrend = monthly;
    } else {
      trendOptions.push(monthly);
      trendOptions.push(quarterly);
      trendOptions.push(yearly);
      this.selectedTrend = quarterly;
    }

    // If we have a previously selected trend that's still valid, use it
    if (this.selectedOption && this.selectedOption.view_type === 'trend') {
      const existingTrendOption = trendOptions.find(opt => opt.field_id === this.selectedOption.field_id);
      if (existingTrendOption) {
        this.selectedTrend = existingTrendOption;
      }
    }

    return trendOptions;
  }


  selectRowFilterOption(filters) {
    this.selectedOption = filters;
    this.tableHeader = this.getTableHeader(this.isDeviationEnabled)
    if (filters.field_id == "project") {
      this.updateComponent(this.raterTypeOb);
    } else {
      this.getOverallSummary();
    }
  }

  /**
  * it updates whole component
  * @param argument 
  */
  updateComponent(argument) {
    if (this.raterTypeOb) {
      this.filterDataBasedOnRaterType(this.raterTypeOb);
    }
  }

  filterDataBasedOnRaterType(rater_type) {
    var allRaterTypeValue = -1; // All rater type
    var others = [2, 7, 8, 9]; // ['Other', '1 to 6 scale', '-3 to +3 scale', '1 to 4 scale]
    this.totalSummary = {
      "current": {},
      "previous": {}
    }
    if (others.includes(rater_type.value)) {
      rater_type.value = 2;
    }
    if (this.overall_summary_details && this.overall_summary_details.brands && rater_type.value !== allRaterTypeValue) {
      this.tableHeader = this.getTableHeader(this.isDeviationEnabled)
      this.getDefaultSummary();
      var tmpData = Helpers.deepClone(this.overall_summary_details);
      for (var key in tmpData.brands) {
        if (!tmpData.brands.hasOwnProperty(key)) continue;
        if (tmpData.brands[key].main_rater_type != rater_type.value) {
          delete tmpData.brands[key]
          if (tmpData.overall_summary[key]) {
            delete tmpData.overall_summary[key]
          }
        }
      }
      this.processHierarchyData(tmpData);
    } else {
      this.tableHeader = this.getTableHeader(this.isDeviationEnabled);
    }
    if (rater_type.value == -1 || rater_type.value == 2 || !rater_type) {
      var detailsHeader = this.tableHeader;
      let pos = detailsHeader.map(function (e) { return e.field_name; }).indexOf('response_score');
      if (pos > 0) {
        detailsHeader.splice(pos, 1);
      }
      this.tableHeader = detailsHeader;
      if (rater_type.value < 1 && this.selectedOption?.view_type == "hierarchy") {
        this.processHierarchyData(this.overall_summary_details);
      }
    }
  }

  /**
  * return table header for different tables
  * @param isDeviationEnabled 
  * @returns 
  */
  getTableHeader(isDeviationEnabled) {
    var tableHeader: any[] = [];
    var display_text_name = (this.selectedOption?.view_type == "trend") ? "Date" : "Request parameters";

    tableHeader.push({
      "field_name": "name",
      "display_name": display_text_name,
      "order": 1,
      "width": "30%"
    })
    this.requestsJourneyHeader = this.requestsJourneyHeader.map((column: any) => ({
      ...column,
      is_deviation_enabled: !!isDeviationEnabled && !!column.sortBy
    }));
    var detailsHeader = this.requestsJourneyHeader;
    tableHeader = tableHeader.concat(detailsHeader);

    return tableHeader
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['isDeviationEnabled'] && !changes['isDeviationEnabled'].firstChange) {
      this.getTableHeader(this.isDeviationEnabled);
      if (this.isDataLoaded && !this.restrictToday) {
        if (this.isDeviationEnabled) {
          this.getOverallSummary();
        } else {
          this.refreshCurrentViewData();
        }
      }
    } else if (changes['isDeviationEnabled']) {
      this.getTableHeader(this.isDeviationEnabled);
    }
  }

  private applyFormattedValuesToDataClone(): void {
    this.dataClone = this.dataClone.map(item => ({
      ...item,
      formated_number_of_requests_received: this.formatNumber(item.number_of_requests_received),
      formated_number_of_requests_filtered: this.formatNumber(item.number_of_requests_filtered),
      formated_number_of_requests_eligible: this.formatNumber(item.number_of_requests_eligible),
      formated_number_of_requests_all_attempts_failed: this.formatNumber(item.number_of_requests_all_attempts_failed),
      formated_number_of_unique_requests_sent: this.formatNumber(item.number_of_unique_requests_sent),
      formated_number_of_requests_undelivered: this.formatNumber(item.number_of_requests_undelivered),
      formated_number_of_unique_requests_delivered: this.formatNumber(item.number_of_unique_requests_delivered),
      formated_feedback_link_open_count: this.formatNumber(item.feedback_link_open_count),
      formated_number_of_request_generated_rated: this.formatNumber(item.number_of_request_generated_rated),
      formated_response_rate: this.formatNumber(item.response_rate) + "%",
    }));
  }

  private updateFooterData(): void {
    this.footerData = this.buildFooterData();
  }

  private buildFooterData(): any {
    if (!this.dataClone.length || _.isEmpty(this.totalSummary.current)) {
      return null;
    }

    const totalRow = this.prepareSummaryData({
      summary: {
        current: Helpers.deepClone(this.totalSummary.current),
        previous: Helpers.deepClone(this.totalSummary.previous),
      }
    }, true);

    totalRow.name = 'Total';
    totalRow.formated_number_of_requests_received = this.formatNumber(totalRow.number_of_requests_received);
    totalRow.formated_number_of_requests_filtered = this.formatNumber(totalRow.number_of_requests_filtered);
    totalRow.formated_number_of_requests_eligible = this.formatNumber(totalRow.number_of_requests_eligible);
    totalRow.formated_number_of_requests_all_attempts_failed = this.formatNumber(totalRow.number_of_requests_all_attempts_failed);
    totalRow.formated_number_of_unique_requests_sent = this.formatNumber(totalRow.number_of_unique_requests_sent);
    totalRow.formated_number_of_requests_undelivered = this.formatNumber(totalRow.number_of_requests_undelivered);
    totalRow.formated_number_of_unique_requests_delivered = this.formatNumber(totalRow.number_of_unique_requests_delivered);
    totalRow.formated_feedback_link_open_count = this.formatNumber(totalRow.feedback_link_open_count);
    totalRow.formated_number_of_request_generated_rated = this.formatNumber(totalRow.number_of_request_generated_rated);
    totalRow.formated_response_rate = this.formatNumber(totalRow.response_rate) + '%';

    if (!this.isDeviationEnabled) {
      delete totalRow.deviations;
    }

    return totalRow;
  }

  private refreshCurrentViewData(): void {
    if (!this.overall_summary_details || !this.isDataLoaded) {
      return;
    }

    this.getTableHeader(this.isDeviationEnabled);

    const viewType = this.selectedOption?.view_type ?? this.trenddatacache?.view_type;
    if (viewType === 'trend') {
      this.totalSummary = { current: {}, previous: {} };
      this.processTrendsdata(this.overall_summary_details);
    } else {
      this.filterDataBasedOnRaterType(this.raterTypeOb);
    }

    this.applyFormattedValuesToDataClone();
    this.updateFooterData();

    this.feedSearch.options = this.dataClone;
    const searchTerm = this.searchTerm?.trim().toLowerCase();
    if (searchTerm) {
      this.feedSearch.filteredOptions = this.dataClone.filter((option) =>
        option?.name?.toLowerCase?.().includes(searchTerm)
      );
    } else {
      this.feedSearch.filteredOptions = [...this.dataClone];
    }

    this.updatePagingDetails(
      this.feedSearch.filteredOptions.length,
      this.pagingDetails?.pageNumber || 1,
      this.feedSearch.filteredOptions
    );
    this.cdr.detectChanges();
  }

  sortFeedList(event: any) {
    if (event) {
      // Reverse the sortOrder logic - when event.sorted is true, we want descending order
      const sortOrder = event.sorted ? 'desc' : 'asc';
      const field = event.sortBy || event.dataKey;

      // Update header sorting indicators
      this.requestsJourneyHeader = _.map(this.requestsJourneyHeader, (column: any) => {
        if (column.dataKey === event.dataKey) {
          column.isColumnSorted = true;
          column.sorted = event.sorted;
          column.sortingEnabled = true;
        } else {
          delete column.isColumnSorted;
          delete column.sorted;
        }
        return column;
      });

      // Get the correct source data based on whether there's an active search
      const sourceData = this.feedSearch.filteredOptions.length
        ? this.feedSearch.filteredOptions
        : this.dataClone;

      // Sort the entire dataset
      const sortedData = _.orderBy(
        sourceData,
        [(item) => {
          let value = item[field];

          // Special handling for the 'name' field (dates)
          if (field === 'name') {
            // Use time_in_millisecond for date sorting
            return item.time_in_millisecond;
          }

          // Handle formatted number fields
          if (field.startsWith('formated_')) {
            const numericField = field.replace('formated_', '');
            value = item[numericField]; // Use the original numeric value
          }

          // Handle percentage values (e.g. "45%")
          if (typeof value === 'string') {
            if (value.endsWith('%')) {
              return Number(value.replace(/[%,]/g, '')) || 0;
            }
            // Remove commas and convert to number if possible
            const numValue = Number(value.replace(/,/g, ''));
            return isNaN(numValue) ? value : numValue;
          }

          // Handle numeric values
          return typeof value === 'number' ? value : -Infinity;
        }],
        [sortOrder]
      );

      // Store the sorted data
      this.sortedData = sortedData;

      // Reset to first page and update pagination
      this.pagingDetails.pageNumber = 1;
      this.updatePagingDetails(sortedData.length, 1, sortedData);

      // Force change detection
      this.cdr.detectChanges();
    }
  }



  updatePagingDetails(totalfeeds: number, pageNumber: number, filteredData: any[]) {
    if (totalfeeds === 0) {
      this.pagingDetails = {
        start: 0,
        end: 0,
        pageSize: this.pagingDetails.pageSize,
        pageNumber: 1,
        total: 0,
        totalpages: 0,
      };
      this.pagingButtons = {
        isFirst: false,
        isPrevious: false,
        isNext: false,
        isLast: false,
      };
      this.tableData = [];
      return;
    }

    // Calculate pagination values
    const start = ((pageNumber - 1) * this.pagingDetails.pageSize) + 1;
    const end = Math.min(pageNumber * this.pagingDetails.pageSize, totalfeeds);
    const totalpages = Math.ceil(totalfeeds / this.pagingDetails.pageSize);

    // Update paging details
    this.pagingDetails = {
      start,
      end,
      pageSize: this.pagingDetails.pageSize,
      pageNumber,
      total: totalfeeds,
      totalpages,
    };

    // Update navigation buttons
    this.pagingButtons = {
      isFirst: pageNumber > 1,
      isPrevious: pageNumber > 1,
      isNext: pageNumber < totalpages,
      isLast: pageNumber < totalpages,
    };

    // Update table data for the current page
    const startIndex = start - 1;
    const endIndex = end;
    this.tableData = filteredData.slice(startIndex, endIndex);
  }

  paginateData(pagingType: string) {
    // Always use the base data source if no sorting or filtering is applied
    const sourceData = this.sortedData.length ? this.sortedData :
      (this.feedSearch.filteredOptions.length ?
        this.feedSearch.filteredOptions :
        this.dataClone);
    console.log('dataClone', this.dataClone, 'sourceData', sourceData, 'pagingType', pagingType);
    if (!sourceData || !sourceData.length) {
      return; // Guard against empty data
    }

    let newPageNumber = this.pagingDetails.pageNumber;

    switch (pagingType) {
      case 'next':
        newPageNumber = Math.min(newPageNumber + 1, this.pagingDetails.totalpages);
        break;
      case 'previous':
        newPageNumber = Math.max(newPageNumber - 1, 1);
        break;
      case 'first':
        newPageNumber = 1;
        break;
      case 'last':
        newPageNumber = this.pagingDetails.totalpages;
        break;
    }

    this.updatePagingDetails(sourceData.length, newPageNumber, sourceData);
  }

  ngOnDestroy(): void {
    // we've destroyed the component, so update the subject
    this.Subscription?.unsubscribe()
    this.engagementService.selectedRaterType = {};
  }

}